import { IconError } from './svg/IconError';

import './Icon.style.sass';

export const WarningRed = () => (
  <div className="warning-red">
    <IconError />
  </div>
);
